/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Create_UserInputs */

const en_error_create_user = /** @type {(inputs: Error_Create_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create user`)
};

const ja_error_create_user = /** @type {(inputs: Error_Create_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーの作成に失敗しました`)
};

const fr_error_create_user = /** @type {(inputs: Error_Create_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la création de l'utilisateur`)
};

const de_error_create_user = /** @type {(inputs: Error_Create_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer konnte nicht erstellt werden`)
};

/**
* | output |
* | --- |
* | "Failed to create user" |
*
* @param {Error_Create_UserInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const error_create_user = /** @type {((inputs?: Error_Create_UserInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Create_UserInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_create_user(inputs)
	if (locale === "ja") return ja_error_create_user(inputs)
	if (locale === "fr") return fr_error_create_user(inputs)
	return de_error_create_user(inputs)
});